// extracted by mini-css-extract-plugin
export default {"root":"PaymentSettlementListPage_root__Nrb-A","settlement-page-search":"PaymentSettlementListPage_settlement-page-search__GJgP6"};